module.exports = __webpack_public_path__ + "static/img/6.1088729.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgzgk/6.png
// module id = OAk2
// module chunks = 0